import { Injectable, ComponentFactoryResolver, ApplicationRef, Injector, EmbeddedViewRef, ComponentRef, Type, HostListener } from '@angular/core';
import { DialogConfig } from './is-dialog-config';
import { ISDialogComponent } from './is-dialog.component';
import { DialogRef } from './is-dialog-ref';
import { DialogInjector } from './is-dialog-injector';

@Injectable({
  providedIn: 'root'
})
export class ISDialogService {
  dialogComponentRefs: ComponentRef<ISDialogComponent>[] = [];

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  public open(componentType: Type<any>, config: DialogConfig): DialogRef {
    const dialogRef = this.appendDialogComponentToBody(config);

    const dialogComponentRef = this.dialogComponentRefs[this.dialogComponentRefs.length - 1];
    dialogComponentRef.instance.childComponentType = componentType;
    return dialogRef;
  }

  
  public close(data?: any) {
   
  }

  public getDialogRef(predicate: (dialogInstance: ISDialogComponent) => boolean): DialogRef | null {
    let dialogComponentRef = this.dialogComponentRefs.find( (cmpRef) => predicate(cmpRef.instance) );
    
    if (dialogComponentRef) {
      return dialogComponentRef.instance.dialogRef;
    } else {
      return null;
    }
  }

    public getDialogInstance(predicate: (dialogInstance: ISDialogComponent) => boolean): ISDialogComponent | null {
    let dialogComponentRef = this.dialogComponentRefs.find( (cmpRef) => predicate(cmpRef.instance) );
    
    if (dialogComponentRef) {
      return dialogComponentRef.instance;
    } else {
      return null;
    }
  }

  private appendDialogComponentToBody(config: DialogConfig): DialogRef {
    const map = new WeakMap();
    map.set(DialogConfig, config);

    const dialogRef = new DialogRef();
    map.set(DialogRef, dialogRef);

    const sub = dialogRef.afterClosed.subscribe(() => {
      // close the dialog
      this.removeDialogComponentFromBody(dialogComponentRef);
      sub.unsubscribe();
    });

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(ISDialogComponent);
    const componentRef = componentFactory.create(new DialogInjector(this.injector, map));
    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    this.dialogComponentRefs.push(componentRef);

    const dialogComponentRef = componentRef;
    dialogComponentRef.instance.onClose.subscribe(() => {
      this.removeDialogComponentFromBody(dialogComponentRef);
    });
    
    return dialogRef;
  }

  private removeDialogComponentFromBody(dialogComponentRef: ComponentRef<ISDialogComponent>): void {
    const index = this.dialogComponentRefs.indexOf(dialogComponentRef);
    if (index !== -1) {
      this.appRef.detachView(dialogComponentRef.hostView);
      dialogComponentRef.destroy();
      this.dialogComponentRefs.splice(index, 1);
    }
  }
}
